import { render } from "./UiRadio.vue?vue&type=template&id=a9ccef68&ts=true"
import script from "./UiRadio.vue?vue&type=script&lang=ts"
export * from "./UiRadio.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__